import "./SleepMedicine.module.css";
import Header from "@/reusable_sections/Header";
import RestorativeSleepSolutions from "./sections/RestorativeSleepSolutions";
import SleepEvaluationCpapCare from "./sections/SleepEvaluationCpapCare";
import Footer from "@/reusable_sections/Footer";
export default function SleepMedicinePage() {
  return <div>
      <Header />
      <RestorativeSleepSolutions />
      <SleepEvaluationCpapCare />
      <Footer />
    </div>;
}